import { IonContent, IonIcon } from '@ionic/react';
import { globeOutline } from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL, S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { apiV1GetMeAuthRequest } from '@/modules/api/index.ts';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useTransBotInfo } from '@/pages/Onboarding/Layouts/OwnAI_Trans/hooks/useTransBotInfo';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import { StoresLinks, SuccessPageStyles, WebVersionLink } from './Trans.styles';

const TransVariant: React.FC = () => {
  const { user } = useAccount();
  const [authToken, setAuthToken] = React.useState<string | null>(null);
  const { imageUrl } = useTransBotInfo('paywall');

  React.useEffect(() => {
    const fetchAuthToken = async () => {
      const auth = await apiV1GetMeAuthRequest();
      setAuthToken(auth.token);
    };
    fetchAuthToken();
  }, []);

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  return (
    <SuccessPageStyles
      background={'purple-gradient'}
      backgroundImage={imageUrl}
    >
      <IonContent>
        <div className={'image-container'} />
        <div className="content">
          <OnboardingTitle className="success-payment-title">
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>
          <div className="next-actions">
            <UiTypography
              align="center"
              variant="body-large"
              className="next-action-description"
            >
              Choose the platform
            </UiTypography>
            <StoresLinks>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('appstore')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/appstore.png`}
                  alt="appstore"
                />
              </a>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('googleplay')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/googleplay.png`}
                  alt="googleplay"
                />
              </a>
            </StoresLinks>

            {webCampaign.setup.hasWebAppLink && !!authToken && (
              <WebVersionLink>
                <a href={webCampaign.getAuthUrl(authToken)} target="_blank">
                  <IonIcon icon={globeOutline} />
                  <UiTypography
                    variant="label-large"
                    color="white"
                    component="span"
                  >
                    Web version
                  </UiTypography>
                </a>
              </WebVersionLink>
            )}

            <UiTypography variant="body-large" align="center">
              OR download the app via the link we sent to your email,{' '}
              {user?.email} (check Inbox and Spam).
            </UiTypography>
          </div>

          <div className="questions-email">
            <UiTypography variant="body-large" align="center">
              If you have any questions - reach us at{' '}
              <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`}>
                {DIALOGUE_SUPPORT_EMAIL}
              </a>
            </UiTypography>
          </div>
        </div>
      </IonContent>
    </SuccessPageStyles>
  );
};

export default TransVariant;
